import clsx from 'clsx';
import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function SafeDrivingMainTripLoadingKr() {
  const {t} = useInferableTranslation();

  return (
    <>
      <div className="section_container safe_driving_major skeleton">
        <div className="section_container_header">
          <h3 className="title_xxsmall">{t('T20013')}</h3>
        </div>
        <p className="section_container_desc">{t('T20014')}</p>

        <div className="tabbar type_brick">
          <button
            type="button"
            className={clsx('tabbar_item body_small_b', 'is-selected')}
          >
            {t('T20015')}
          </button>
          <button
            type="button"
            className={clsx('tabbar_item body_small_b', 'is-selected')}
          >
            {t('T20016')}
          </button>
        </div>

        <div className="tab_content driving_danger">
          <ul className="major_driving_list">
            {/*<Suspense fallback={<SafeDrivingMainTripItemLoadingKr />}>*/}
            {/*  <SafeDrivingMainTripListKr*/}
            {/*    vin={vin}*/}
            {/*    selectedTripTab={TripTab.SAFE_DRIVING}*/}
            {/*    currentPage={MAIN_TRIP_DEFAULT_PAGE}*/}
            {/*  />*/}
            {/*</Suspense>*/}
            {/*{safeDrivingCurrentPage === MAIN_TRIP_DEFAULT_PAGE + 1 && (*/}
            {/*  <Suspense fallback={<SafeDrivingMainTripItemLoadingKr />}>*/}
            {/*    <SafeDrivingMainTripListKr*/}
            {/*      vin={vin}*/}
            {/*      selectedTripTab={TripTab.SAFE_DRIVING}*/}
            {/*      currentPage={MAIN_TRIP_DEFAULT_PAGE + 1}*/}
            {/*    />*/}
            {/*  </Suspense>*/}
            {/*)}*/}
          </ul>
          <button
            type="button"
            className="btn_unfold"
            aria-expanded={true}
            aria-controls="majorDrivingDangerMore"
          >
            <span className="unfold_text">{t('T20134')}</span>
            <span className="fold_text">{t('T20135')}</span>
            <span className="ic ic_arrow_down_14px"></span>
          </button>
        </div>
      </div>
    </>
  );
}

export default SafeDrivingMainTripLoadingKr;
